import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createContext, memo, useContext, useLayoutEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var KeepAliveContext = /*#__PURE__*/createContext({
  activeName: undefined,
  setActiveName: function setActiveName() {}
});
export var useKeepAliveContext = function useKeepAliveContext() {
  return useContext(KeepAliveContext);
};
function KeepAliveProvider(props) {
  var initialActiveName = props.initialActiveName,
    children = props.children;
  var _useState = useState(initialActiveName),
    _useState2 = _slicedToArray(_useState, 2),
    activeName = _useState2[0],
    setActiveName = _useState2[1];
  useLayoutEffect(function () {
    setActiveName(initialActiveName);
  }, [initialActiveName]);
  return /*#__PURE__*/_jsx(KeepAliveContext.Provider, {
    value: {
      activeName: activeName,
      setActiveName: setActiveName
    },
    children: children
  });
}
export default /*#__PURE__*/memo(KeepAliveProvider);